import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=6b95389b"
import script from "./Root.vue?vue&type=script&lang=ts"
export * from "./Root.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@7.1.2_@rspack+core@2.1.8_webpack_f466358972556fe7b5b12d81e04c66c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports